<template>
  <table class="product-category-assignment-table uk-margin-remove-top uk-table uk-table-divider uk-table-justify">
    <thead>
      <tr>
        <th>{{ $t('fields.tenant') }}</th>
        <th>{{ $t('fields.category') }}</th>
        <th v-if="showActions"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(category, index) in productCategories">
        <td>
          <router-link
            v-if="isAuthenticatedAsAdmin"
            :to="{ name: 'tenant', params: { id: category.tenant.id } }"
          >
            {{ category.tenant.name }}
          </router-link>
          <span v-else>{{ category.tenant.name }}</span>
        </td>
        <td>
          <router-link
            :to="{ name: 'product-category', params: { id: category.id } }"
          >
            <product-category-hierarchy :category="category" />
          </router-link>
        </td>
        <td v-if="showActions">
          <data-grid-actions
            @edit="onEditItem(index)"
            @remove="onRemoveItem(index)"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import UIkit from 'uikit';
import { mapGetters } from 'vuex';
import DataGridActions from '@/components/DataGridActions';
import ProductCategoryHierarchy from '@/components/ProductCategoryHierarchy';

export default {
  name: 'product-category-assignment-table',
  components: {
    DataGridActions,
    ProductCategoryHierarchy,
  },
  props: {
    productCategories: {
      type: Array,
      required: true,
    },
    showActions: Boolean,
  },
  computed: mapGetters(['isAuthenticatedAsAdmin']),
  methods: {
    onEditItem(index) {
      this.$emit('edit', index);
    },
    onRemoveItem(index) {
      UIkit.modal.confirm(this.$t('confirmations.removeProductCategory'))
           .then(() => { this.$emit('remove', index); })
           .catch(() => {});
    },
  },
  i18n: {
    messages: {
      de: {
        confirmations: {
          removeProductCategory: 'Die Produktkategorie wirklich entfernen?',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductCategoryAssignmentTable.vue?f02e5526